import type { Capture, Identity, Role } from './types';

/**
 * The service's own capability table, mirrored so a screen offers only what the service would accept and
 * says why the rest is not offered where the person reaches for it. The service decides; this decides what
 * to show.
 */
export class Policy {
	static role(identity: Identity | undefined, organization: string): Role | undefined {
		return identity?.organizations.find(entry => entry.organization === organization)?.role;
	}

	static deletes(identity: Identity | undefined, organization: string): boolean {
		const role = Policy.role(identity, organization);
		return role === 'owner' || role === 'admin';
	}

	static edits(identity: Identity | undefined, organization: string): boolean {
		const role = Policy.role(identity, organization);
		return role === 'owner' || role === 'admin' || role === 'developer';
	}

	/** Whoever started a pending snapshot cancels it, and an owner or admin cancels anyone's (decision E9) */
	static cancels(identity: Identity | undefined, capture: Capture): boolean {
		return Boolean(identity && (identity.account === capture.author || Policy.deletes(identity, capture.organization)));
	}
}
